import React from "react";
import { contact } from "../data/contact";
export function ContactSection() {
  return <section id="contacto" aria-labelledby="contacto-titulo" className="bg-cocoa-950 py-14 text-center text-cream-100 sm:py-20" data-id="element-55" data-mp="2z91trpzvohso">
      <div className="mx-auto max-w-2xl px-5" data-id="element-56" data-mp="2kkym8c66sy1r">
        <h2 id="contacto-titulo" className="font-display text-2xl italic text-cream-50 sm:text-3xl" data-id="element-57" data-mp="2piqdd3z0cg4w">
          De tu cocina <span className="text-caramel-400" data-id="element-58" data-mp="3d8krdov2caqq">a tus primeros pedidos</span>
        </h2>
        <p className="mt-4 leading-relaxed text-cream-200" data-id="element-59" data-mp="3i7e2xbqshro9">{contact.tagline}</p>
        <p className="mt-4 font-display text-lg italic text-cream-300" data-id="element-60" data-mp="3i5beux9768m6">“{contact.quote}”</p>
      </div>
    </section>;
}